import { ref, readonly } from 'vue';

interface ToastItem {
  readonly id: number;
  readonly message: string;
  readonly variant: 'success' | 'error' | 'info' | 'warning';
  readonly timeout: number;
}

const toasts = ref<ToastItem[]>([]);
let seq = 0;

function push(item: Omit<ToastItem, 'id'>): void {
  const id = ++seq;
  toasts.value = [...toasts.value, { ...item, id }];
  if (item.timeout > 0) {
    setTimeout(() => dismiss(id), item.timeout);
  }
}

function dismiss(id: number): void {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

/** Composable de toast — estado global mínimo, sem regra de negócio. */
export function useToast() {
  return {
    toasts: readonly(toasts),
    success: (message: string, timeout = 4000) =>
      push({ message, variant: 'success', timeout }),
    error: (message: string, timeout = 6000) =>
      push({ message, variant: 'error', timeout }),
    info: (message: string, timeout = 4000) =>
      push({ message, variant: 'info', timeout }),
    warning: (message: string, timeout = 5000) =>
      push({ message, variant: 'warning', timeout }),
    dismiss,
  };
}
